module.exports = __webpack_public_path__ + "img/programme1.d8533a1a.png";